import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  isLoadingSelector,
  successSelector
} from 'src/store/selectors/statusSelector';

import { selectBuroValidation } from 'src/store/selectors/clientSelectors';
import {
  CLEAR_CLIENT_BURO_VALIDATION_DETAIL,
  LOAD_CLIENT_BURO_VALIDATION_DETAIL,
  loadClientBuroValidationDetail
} from 'src/store/actions/clientActions';
import AlertWithLink from 'src/components/Alert/AlertWithLink/AlertWithLink';
import { Link } from 'react-router-dom';
import { MoffinScoreRange } from 'src/utils/constants/clients';

const ClientBuroValidationAlert = ({ clientId, onWarningStateChange }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const clientBuroValidation = useSelector(selectBuroValidation);

  const loading = useSelector(
    isLoadingSelector([LOAD_CLIENT_BURO_VALIDATION_DETAIL.action])
  );
  const success = useSelector(
    successSelector([LOAD_CLIENT_BURO_VALIDATION_DETAIL.action])
  );

  const [showValidationWarning, setShowValidationWarning] = useState(false);

  useEffect(() => {
    setShowValidationWarning(false);
  }, [clientId]);

  useEffect(() => {
    dispatch(loadClientBuroValidationDetail(clientId));
    return () => {
      dispatch({ type: CLEAR_CLIENT_BURO_VALIDATION_DETAIL });
    };
  }, [clientId, dispatch]);

  useEffect(() => {
    if (
      !loading &&
      success &&
      clientBuroValidation?.creditProfileValidation?.moffinScoreStatus ===
        MoffinScoreRange.FAIL
    ) {
      setShowValidationWarning(true);
    }
  }, [loading, success, clientBuroValidation]);

  useEffect(() => {
    onWarningStateChange?.(showValidationWarning);
  }, [showValidationWarning, onWarningStateChange]);

  if (!showValidationWarning) return null;

  return (
    <AlertWithLink
      severity="warning"
      text={t('ALERTS.BURO_VALIDATION_WARNING')}
      open={showValidationWarning}
      link={
        <Link to={`/clients/detail/${clientId}/buro`}>
          {t('LINKS.VIEW_VALIDATION_BURO_DETAILS')}
        </Link>
      }
      handleClose={() => setShowValidationWarning(false)}
    />
  );
};

ClientBuroValidationAlert.propTypes = {
  clientId: PropTypes.string,
  onWarningStateChange: PropTypes.func
};

export default ClientBuroValidationAlert;
